import "@/App.css";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/site/SmoothScroll";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Ribbon from "@/components/site/Ribbon";
import Services from "@/components/site/Services";
import About from "@/components/site/About";
import Manifesto from "@/components/site/Manifesto";
import Locations from "@/components/site/Locations";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

function App() {
  return (
    <div className="App grain">
      <SmoothScroll>
        <Header />
        <main>
          <Hero />
          <Ribbon />
          <Services />
          <About />
          <Manifesto />
          <Locations />
          <Contact />
        </main>
        <Footer />
      </SmoothScroll>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#111111",
            border: "1px solid #27272a",
            color: "#f4f4f5",
            borderRadius: "0",
          },
        }}
      />
    </div>
  );
}

export default App;
